import {ContentState, EditorState} from 'draft-js';

function stringToDraftState(string = '') {
  const cleanedString = string.replace(/\n+/g, `\n`);
  const emptyDraftState = EditorState.createEmpty();

  return EditorState.push(
    emptyDraftState,
    ContentState.createFromText(cleanedString),
  );
}

export default stringToDraftState;
